/* SALE CLOCK */
ShappifySaleEnds = new Date("August 2, 2026 23:59:59");
ShappifyToday = new Date();

shappify_count_down_maindiv = document.getElementById("product-sales-clock");
shappify_count_down_el = document.getElementById("shappify_count_down");
shappify_count_down_el_top = document.getElementById("shappify_count_down_top");
shappify_count_down_el_top_mob = document.getElementById("shappify_count_down_top_mob");
shappify_count_down_el_pure_fbox = document.getElementById("pure-fbox");
//shappify_count_down_el_topspace = document.getElementById("topspace");

shappify_sale_over_label = "Sale is over";
shappify_sale_ends_in_label = "Sale ends in";
shappify_day_label = "day";
shappify_days_label = "days";
shappify_hour_label = "hr";
shappify_hours_label_mob = "hrs";
shappify_hours_label = "hrs";
shappify_minute_label = "min";
shappify_minutes_label = "mins";
shappify_second_label = "s";
shappify_seconds_label = "s";

if(typeof shappify_overwrite_sales_clock_text == 'function')
{
  shappify_overwrite_sales_clock_text();
}

ShappCountdown();
setInterval("ShappCountdown()",1000);

function ShappCountdown(){
  var day_label = shappify_day_label, hour_label =  shappify_hour_label, minute_label = shappify_minute_label, second_label=shappify_second_label;
  var days = 0;var hours = 0;var minutes = 0;var seconds = 0; 
  var difference = 0; 

  difference = ShappifySaleEnds - ShappifyToday; 
  days = Math.floor(difference/(1000*60*60*24));

  difference = difference - (days * 1000*60*60*24);
  hours = Math.floor(difference/(1000*60*60));

  difference = difference - (hours * 1000*60*60);
  minutes = Math.floor(difference/(1000*60));

  difference = difference - (minutes * 1000*60);
  seconds = Math.floor(difference/(1000));

  if(days != 1) day_label = shappify_days_label;
  if(hours != 1) hour_label = shappify_hours_label;
  if(minutes != 1) minute_label = shappify_minutes_label;
  if(seconds != 1) second_label = shappify_seconds_label;

  if(days<0){
    if(shappify_count_down_el){
      shappify_count_down_el.innerHTML = shappify_sale_over_label;
    }
    
    shappify_count_down_el_top.innerHTML = shappify_sale_over_label;
    shappify_count_down_el_top.style.display = 'none';
    shappify_count_down_el_pure_fbox.style.width = '100%';
    shappify_count_down_el_pure_fbox.style.textAlign = 'center';
      
    /*//shappify_count_down_el_topspace.style.display = 'none';*/
  }
  if(days>=0)  {
    if(shappify_count_down_el){
      shappify_count_down_el.innerHTML = shappify_sale_ends_in_label + 
        " " + days +" "+ day_label +
        ", "+ hours +" " +hour_label +
        ", "+ minutes +" " +minute_label +
        ", "+ seconds +second_label ;
      shappify_count_down_maindiv.style.display = 'block';
    }
  
   shappify_count_down_el_top.innerHTML = "SALE ENDS: " + 
      " " + days +" "+ day_label +
      ", "+ hours +" " +hour_label +
      ", "+ minutes +" " +minute_label +
      ", "+ seconds +second_label ;
    shappify_count_down_el_top_mob.innerHTML = "SALE ENDS: " + 
      " " + days +" "+ day_label +
      ", "+ hours +" " +shappify_hours_label_mob +
      ", "+ minutes +" " +minute_label +
      ", "+ seconds +second_label ;
  
  }

  ShappifyToday.setSeconds(ShappifyToday.getSeconds() + 1);

}
/* SALE CLOCK ENDS */

/* SALE CLOCK MOB SLIDER */
jQuery('.sale-topbar-mob').slick({
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  vertical: true,
  verticalSwiping: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000
});
/* SALE CLOCK MOB SLIDER ENDS */